import React from 'react';
import axios, {AxiosError} from "axios";
import {Button, FormControl, Typography, CircularProgress} from "@material-ui/core";
import {connect} from "react-redux";
import logo from '../../icons/img/CropSense.png';
import TextField from "@material-ui/core/TextField";
import {Visibility, VisibilityOff} from "@material-ui/icons";
import MobileCarrusel from "./MobileCarrusel";
import Graph from "../../icons/SVGs/ArrowLeft.svg";
import {INotificacion} from "../../types";
import config from "../../config.json";
import {IStore} from "../../store/reducers";
import actionTypes from "../../store/actionTypes";

const texts = require('../../texts/login.json')


interface IProps {
    setForgetPass(forget_pass: boolean): void
    setEmail(email: string): void
    notify(notification: INotificacion): void
    setHover(hover: string): void
    recover_email: string
    hover: string
    idioma: string
}

interface IState {
    error_email: string
    error_code: string
    error_pass: string
    error_confirm_pass: string
    enviado: boolean
    verificando: boolean
    verificado: boolean
    code: string
    pass: string
    confirm_pass: string
    view_pass: boolean
    view_confirm_pass: boolean
    autenticando: boolean
    text: Record<string, string>
}

class MobileLoginForgetPass extends React.Component<IProps, IState> {
    state: IState = {
        error_email: "",
        error_code: "",
        error_pass: "",
        error_confirm_pass: "",
        enviado: false,
        verificando: false,
        verificado: false,
        code: "",
        pass: "",
        confirm_pass: "",
        view_pass: false,
        view_confirm_pass: false,
        autenticando: false,
        text: texts[this.props.idioma]
    };

    sendEmail = () => {
        this.setState({verificando: true})
        axios.get(config.url+`/send/code?email=${this.props.recover_email}&recover=${true}`)
            .then((res) => {
                setTimeout(() => this.setState({
                    verificando: false,
                    verificado: true
                }), 1500)
            })
            .catch((error) => {
                this.setState({verificando: false})
                if (error.response.status === 404) {
                    this.setState({error_email: this.state.text["10"]})
                } else {
                    this.props.notify({message: this.state.text["11"], variant: 'error'})
                }
            })

    }

    preparado = () : boolean => {
        if (this.state.code.length === 0) return false
        if (this.state.pass.length === 0) return false
        if (this.state.confirm_pass.length === 0) return false
        if (this.state.error_code) return false
        if (this.state.error_pass) return false
        if (this.state.error_confirm_pass) return false
        if (this.state.autenticando) return false
        return true
    }

    guardarCambios = () => {
        if (this.state.pass !== this.state.confirm_pass) {
            this.setState({error_confirm_pass: this.state.text["12"]})
            return
        }
        if (this.state.pass.length < 6) {
            this.setState({error_pass: this.state.text["13"]})
            return
        }
        if (this.state.pass.toLowerCase() === this.state.pass) {
            this.setState({error_pass: this.state.text["14"]})
            return
        }
        if (!/\d/.test(this.state.pass)) {
            this.setState({error_pass: this.state.text["15"]})
            return
        }

        this.setState({autenticando: true})
        axios.get(config.url+`/recuperar/cuenta?email=${this.props.recover_email}&code=${this.state.code}&pass=${this.state.pass}`)
            .then((res) => {
                setTimeout(() => this.cambiosGuardados(), 1500)
            })
            .catch((error) => {
                this.setState({autenticando: false})
                if (error.response.status === 404) {
                    this.setState({error_code: this.state.text["16"]})
                } else {
                    this.props.notify({message: this.state.text["17"], variant: 'error'})
                }
            })

    }

    cambiosGuardados = () => {
        this.props.notify({message: this.state.text["18"], variant: 'success'})
        this.setState({autenticando: false})
        this.props.setEmail('')
        this.props.setForgetPass(false)
    }


    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100vh',
                    width: '100vw',
                    overflow: 'auto',
                    alignItems: 'center',
                    verticalAlign: 'center'
                }}
            >

                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: '80%',
                        justifyContent: "space-between",
                        marginTop: 30,
                    }}
                >
                    <img
                        width='70%'
                        src={logo}
                        alt=''
                    />
                    <img
                        style={{
                            height: 50,
                            width: 50,
                            cursor: "pointer",
                            marginRight: -40
                        }}
                        src={Graph}
                        alt="wthr img"
                        onClick={() => this.props.setForgetPass(false)}
                    />

                </div>



                <Typography
                    style={{
                        color: "#4C494B",
                        fontSize: 18,
                        fontFamily: "Poppins",
                        marginTop: 80,
                        width: '80%'
                    }}
                >
                    {this.state.text["19"]}
                </Typography>

                <TextField
                    style={{
                        margin: 8,
                        width: '80%',
                        fontSize: 30
                    }}
                    inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                    InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                    disabled={this.state.verificado}
                    value={this.props.recover_email}
                    error={this.state.error_email.length !== 0}
                    label={this.state.error_email.length !== 0 ? this.state.error_email : "E-Mail"}
                    placeholder={"E-Mail"}
                    onChange={(e) => {
                        this.props.setEmail(e.target.value)
                        if (this.state.error_email.length !== 0) this.setState({error_email: ""})
                    }}
                    onKeyPress={(e) => (e.key === 'Enter') && this.sendEmail()}
                />

                {!this.state.verificado &&
                <Button
                    style={{
                        width: '80%',
                        height: 51,
                        backgroundColor: this.props.recover_email.length === 0 || this.state.verificando ? '#ccc' : '#80ED99',
                        borderRadius: 10,
                        fontSize: 20,
                        marginBottom: 25,
                        marginTop: 20
                    }}
                    variant={'contained'}
                    onClick={() => this.sendEmail()}
                    disabled={this.props.recover_email.length === 0 || this.state.verificando}
                >
                    {this.state.verificando ?
                        <CircularProgress
                            style={{
                                height: 50,
                                width: 50,
                                color: '#b43333'
                            }}
                        />
                        :
                        <Typography
                            style={{
                                color: "#4C494B",
                                fontFamily: "Poppins",
                                fontSize: 20,
                                fontWeight: "bold",
                                textTransform: "none",
                                margin: 10
                            }}
                        >
                            {this.state.text["20"]}
                        </Typography>
                    }
                </Button>
                }

                {this.state.verificado &&
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '80%'
                    }}
                >
                    <Typography
                        style={{
                            color: "#4C494B",
                            fontSize: 18,
                            fontFamily: "Poppins",
                            marginTop: 20,
                            width: '100%'
                        }}
                    >
                        {this.state.text["21"]}
                        <br/>
                        {this.state.text["22"]}
                    </Typography>

                    <TextField
                        style={{
                            width: '100%',
                            fontSize: 30,
                            marginBottom: 20
                        }}
                        inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        value={this.state.code}
                        error={this.state.error_code.length !== 0}
                        label={this.state.error_code.length !== 0 ? this.state.error_code : this.state.text["23"]}
                        placeholder={this.state.text["23"]}
                        onChange={(e) => {
                            this.setState({code: e.target.value})
                            if (this.state.error_code.length !== 0) this.setState({error_code: ""})
                        }}
                        onKeyPress={(e) => this.preparado() && (e.key === 'Enter') && this.guardarCambios()}
                    />

                    <FormControl
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            width: '100%',
                        }}
                    >
                        <TextField
                            style={{
                                width: '100%',
                                fontSize: 30,
                                marginBottom: 20,
                                marginRight: 0
                            }}
                            inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                            InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                            value={this.state.pass}
                            type={this.state.view_pass? 'text' : 'password'}
                            error={this.state.error_pass.length !== 0}
                            label={this.state.error_pass.length !== 0 ? this.state.error_pass : this.state.text["1"]}
                            placeholder={this.state.text["1"]}
                            onChange={(e) => {
                                this.setState({pass: e.target.value})
                                if (this.state.error_pass.length !== 0) this.setState({error_pass: ""})
                            }}
                            onKeyPress={(e) => this.preparado() && (e.key === 'Enter') && this.guardarCambios()}
                        />
                        {this.state.view_pass?
                            <Visibility
                                style={{
                                    width: 30,
                                    height: 30,
                                    cursor: "pointer",
                                    color: this.props.hover === 'vis'? "black" : '#4C494B',
                                    marginTop: -10,
                                    marginLeft: -30,
                                    zIndex: 10
                                }}
                                onMouseEnter={() => this.props.setHover('vis')}
                                onMouseLeave={() => this.props.setHover('')}
                                onClick={() => this.setState({view_pass: false})}
                            />
                            :
                            <VisibilityOff
                                style={{
                                    width: 30,
                                    height: 30,
                                    cursor: "pointer",
                                    color: this.props.hover === 'vis'? "black" : '#4C494B',
                                    marginTop: -10,
                                    marginLeft: -30,
                                    zIndex: 10
                                }}
                                onMouseEnter={() => this.props.setHover('vis')}
                                onMouseLeave={() => this.props.setHover('')}
                                onClick={() => this.setState({view_pass: true})}
                            />
                        }
                    </FormControl>


                    <FormControl
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            width: '100%',
                        }}
                    >
                        <TextField
                            style={{
                                width: '100%',
                                fontSize: 30,
                                marginBottom: 35,
                                marginRight: 0
                            }}
                            inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                            InputLabelProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                            value={this.state.confirm_pass}
                            type={this.state.view_confirm_pass? 'text' : 'password'}
                            error={this.state.error_confirm_pass.length !== 0}
                            label={this.state.error_confirm_pass.length !== 0 ? this.state.error_confirm_pass : this.state.text["24"]}
                            placeholder={this.state.text["24"]}
                            onChange={(e) => {
                                this.setState({confirm_pass: e.target.value})
                                if (this.state.error_confirm_pass.length !== 0) this.setState({error_confirm_pass: ""})
                            }}
                            onKeyPress={(e) => this.preparado() && (e.key === 'Enter') && this.guardarCambios()}
                        />
                        {this.state.view_confirm_pass?
                            <Visibility
                                style={{
                                    width: 30,
                                    height: 30,
                                    cursor: "pointer",
                                    color: this.props.hover === 'vis_conf'? "black" : '#4C494B',
                                    marginTop: -10,
                                    marginLeft: -30,
                                    zIndex: 10
                                }}
                                onMouseEnter={() => this.props.setHover('vis_conf')}
                                onMouseLeave={() => this.props.setHover('')}
                                onClick={() => this.setState({view_confirm_pass: false})}
                            />
                            :
                            <VisibilityOff
                                style={{
                                    width: 30,
                                    height: 30,
                                    cursor: "pointer",
                                    color: this.props.hover === 'vis_conf'? "black" : '#4C494B',
                                    marginTop: -10,
                                    marginLeft: -30,
                                    zIndex: 10
                                }}
                                onMouseEnter={() => this.props.setHover('vis_conf')}
                                onMouseLeave={() => this.props.setHover('')}
                                onClick={() => this.setState({view_confirm_pass: true})}
                            />
                        }
                    </FormControl>


                    <Button
                        style={{
                            width: '100%',
                            height: 51,
                            backgroundColor: this.preparado()? '#80ED99': '#ccc',
                            borderRadius: 10,
                            fontSize: 20,
                            marginBottom: 25,
                            marginTop: 20
                        }}
                        variant={'contained'}
                        onClick={() => this.guardarCambios()}
                        disabled={!this.preparado()}
                    >
                        {this.state.autenticando ?
                            <CircularProgress
                                style={{
                                    height: 50,
                                    width: 50,
                                    color: '#b43333'
                                }}
                            />
                            :
                            <Typography
                                style={{
                                    color: "#4C494B",
                                    fontFamily: "Poppins",
                                    fontSize: 20,
                                    fontWeight: "bold",
                                    textTransform: "none"
                                }}
                            >
                                {this.state.text["25"]}
                            </Typography>
                        }

                        </Button>

                    </div>
                    }

            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    recover_email: state.login.recover_email,
    hover: state.login.hover,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setForgetPass: (forget_pass: boolean) => dispatch({type: "set-login-forget-pass", forget_pass}),
    setEmail: (email: string) => dispatch({type: "set-login-email-recover", email}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    setHover: (hover: string) => dispatch({type: "set-login-hover", hover}),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileLoginForgetPass);
